import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User saved Meta account configuration',
  name: 'meta_account_configuration_saved',
};

export default META;
